import de from 'core/src/locales/dist/de.json';
import en from 'core/src/locales/dist/en.json';
import en_XA from 'core/src/locales/dist/en-xa.json';
import en_XB from 'core/src/locales/dist/en-xb.json';
import es from 'core/src/locales/dist/es.json';
import fr from 'core/src/locales/dist/fr.json';
import pt from 'core/src/locales/dist/pt.json';
import getTreatment from 'core/src/views/modules/flags';

import { createIntl, createIntlCache } from '@formatjs/intl';

const intlIsEnabled = getTreatment('pl_i18n_web') === 'on';

const locale = intlIsEnabled ? (SS.serverBootstrap.siteLocale || 'en').toLowerCase() : 'en';

const messages = {
  'de': de,
  'en': en,
  'en-xa': en_XA,
  'en-xb': en_XB,
  'es': es,
  'fr': fr,
  'pt': pt,
}

const cache = createIntlCache();

export const intl = createIntl(
  {
    locale,
    messages: messages[locale]
  }, 
  cache
);
